import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ExternalLinks } from '../../../../core/constants/external-links';

@Component({
    selector: 'app-sidenav-bottom-panel-info',
    imports: [MatButtonModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './sidenav-bottom-panel-info.component.html',
})
export class SidenavBottomPanelInfoComponent {
    externalLinks = ExternalLinks.enterpriseWireless;
}
